import { Box, Button, TextField, Typography } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { formatDateFromString, formatTime } from "../../utils/date-setup";
import React, { useState } from "react";
import { useNotificationService } from "../../hooks/notification";
import { Chat } from "../../store/messageSlice";

export const DateCover = ({ date }: any) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#E2F1EB",
          borderRadius: 5,
          marginVertical: 2,
          paddingHorizontal: 7,
        }}
      >
        <Typography
          sx={{
            fontSize: 11,
            color: "#7991A4",
          }}
        >
          {formatDateFromString(date)}
        </Typography>
      </Box>
    </Box>
  );
};

export const UserMessage = ({
  chat,
  message_time,
}: {
  chat: Chat;
  message_time: string;
}) => {
  return (
    <Box
      sx={{
        marginTop: 2,
        width: "85%",
        marginLeft: "auto",
        marginRight: 10,
      }}
    >
      <Box
        style={{
          backgroundColor: "#53AD8A",
          padding: 8,
          borderTopRightRadius: 12,
          borderTopLeftRadius: 12,
          borderBottomLeftRadius: 12,
          minHeight: "2rem",
        }}
      >
        <Typography
          style={{
            color: "white",
            fontSize: 12,
            fontWeight: 500,
          }}
        >
          {chat?.message}
        </Typography>
      </Box>
      <Typography
        sx={{
          fontSize: 11,
          textAlign: "right",
          width: "100%",
          color: "#A8A9B2",
        }}
      >
        {formatTime(message_time)}
      </Typography>
    </Box>
  );
};

export const ReplyMessage = ({ chat, message_time }: any) => {
  return (
    <Box
      style={{
        marginTop: 20,
        width: "85%",
        marginLeft: "auto",
      }}
    >
      <Box
        style={{
          backgroundColor: "#FAFAFA",
          padding: 8,
          borderTopRightRadius: 12,
          borderTopLeftRadius: 12,
          borderBottomRightRadius: 12,
          minHeight: "2rem",
        }}
      >
        <Typography
          sx={{
            color: "#141414",
            fontSize: 12,
            fontWeight: 500,
          }}
        >
          {chat?.message}
        </Typography>
      </Box>
      <Typography
        sx={{
          fontSize: 11,
          textAlign: "left",
          width: "100%",
          color: "#A8A9B2",
        }}
      >
        {formatTime(message_time)}
      </Typography>
    </Box>
  );
};

const inputSty = {
  background: "transparent",
  outline: "none",
  border: "none",
  width: "90%",
  fontWeight: 500,
  color: "#000",
  fontSize: "14px",
  "&:placeholder": {
    color: "#92A5B5",
  },
};

interface MessageInputProps {
  sendMessage: (receiverId: number, content: string) => void;
  receiverId: number;
}
export const MessageInput = ({
  sendMessage,
  receiverId,
}: MessageInputProps) => {
  const [message, setMessage] = useState("");
  const { showNotification } = useNotificationService();
  const handleSendMessage = (e: any) => {
    e.preventDefault();
    if (message.trim() === "") {
      showNotification("Kindly input message", "warning");
    } else {
      sendMessage(receiverId, message);
      setMessage("");
    }
  };
  return (
    <Box
      sx={{
        width: "500px",
        position: "fixed",
        bottom: "1rem",
      }}
    >
      <Box
        onSubmit={handleSendMessage}
        component={"form"}
        sx={{
          px: 2,
          py: 1,
          borderRadius: "30px",
          backgroundColor: "#E7EBEF",
          border: "1px solid #C2CDD6",
          padding: "8px",
          width: "100%",
          display: "flex",
          mt: 3,
        }}
      >
        <input
          style={inputSty}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Type message..."
        />

        <Button
          color="primary"
          type="submit"
          sx={{
            color: "#fafafa",
            px: 2,
            borderRadius: 6,
            height: "2rem",
          }}
        >
          <SendIcon color="primary" />
        </Button>
      </Box>
    </Box>
  );
};
